// @flow

import { SET_INTEREST_TYPES, UPDATE_INTEREST_TYPE } from "../actions"

const handleInterestTypeUpdate = ( state: any, action: any ) => {
  const newTypeId = action.interestType.id
  const filteredTypes = state.filter( type => type.id !== newTypeId )
  return [ action.interestType, ...filteredTypes ]
}


export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case UPDATE_INTEREST_TYPE:
    return handleInterestTypeUpdate( state, action )
  case SET_INTEREST_TYPES:
    return action.types
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/interestTypes.jsx